"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NpiDashboardSearchResponse = void 0;
const common_1 = require("../../../common");
const npi_dashboard_data_response_1 = require("./npi-dashboard-data.response");
class NpiDashboardSearchResponse extends common_1.PaginatedResponse {
}
exports.NpiDashboardSearchResponse = NpiDashboardSearchResponse;
//# sourceMappingURL=npi-dashboard-search.response.js.map